// extracted by mini-css-extract-plugin
export default {"footerContainer":"CommonFooter_footerContainer__A4L6Z","nextButton":"CommonFooter_nextButton__XiGF6","previousButton":"CommonFooter_previousButton__C8odl"};